import { BUTTON_STYLE_OPTIONS } from "./heroBannerConstants";

export const getButtonPreviewClass = (style) => {
  switch (style) {
    case "Green":
      return "btn btn-success btn-sm";
    case "Blue":
      return "btn btn-secondary btn-sm";
    case "Light":
      return "btn btn-light btn-sm border";
    default:
      return "btn btn-outline-secondary btn-sm";
  }
};

export const getButtonPreviewBadgeClass = (style) => {
  switch (style) {
    case "Green":
      return "bg-success";
    case "Blue":
      return "bg-secondary";
    case "Light":
      return "bg-light text-dark border";
    default:
      return "bg-secondary-subtle text-secondary";
  }
};

export const getUsedButtonStyles = (buttons, excludeIndex = -1) => {
  if (!Array.isArray(buttons)) return [];
  return buttons
    .map((btn, idx) =>
      idx === excludeIndex
        ? null
        : btn?.buttonStyle || btn?.ButtonStyle || null
    )
    .filter(Boolean);
};

export const getAvailableStyleOptions = (buttons, currentIndex, currentStyle = "") => {
  const used = getUsedButtonStyles(buttons, currentIndex);
  return BUTTON_STYLE_OPTIONS.filter(
    (opt) => !used.includes(opt.value) || opt.value === currentStyle
  );
};

export const hasDuplicateButtonStyles = (buttons) => {
  const styles = (buttons || []).map((b) => b?.buttonStyle).filter(Boolean);
  return new Set(styles).size !== styles.length;
};

export const canAddMoreButtons = (buttons) =>
  (buttons?.length || 0) < 3;
